import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles( {
      wrapper: {
        padding: theme.spacing(2),
        borderRadius: '16px',
        backgroundColor: '#fff',

        [theme.breakpoints.up('md')]: {
          border: '1px solid rgba(26, 17, 24, 0.08)',
          borderRadius: theme.spacing(2),
        },
      },
  })
);

